<template>
  <div>
    <div v-if="!loading" class="dashboard-area">
      <div class="summary-card-container">
        <SummaryCard
          v-bind:cardIcon="jobsCountIcon"
          v-bind:summaryDescription="jobsCountDescription"
          v-bind:totalCount="jobsCount"
          class="linked-card"
          :eventType="jobEvent"
          :target="jobTarget"
          v-on:backToJobs="$emit('backToJobs', 'Jobs')"
        />
      </div>

      <div class="summary-card-container">
        <SummaryCard
          v-bind:cardIcon="applicationsCountIcon"
          v-bind:summaryDescription="applicationsCountDescription"
          v-bind:totalCount="applicationsCount"
          class="linked-card"
          :eventType="applicationEvent"
          :target="applicationTarget"
          v-on:backToApplications="$emit('backToApplications', 'Applications')"
        />
      </div>

      <div class="summary-card-container">
        <SummaryCard
          v-bind:cardIcon="shortlistedCountIcon"
          v-bind:summaryDescription="shortlistedCountDescription"
          v-bind:totalCount="shortlistedCount"
        />
      </div>

      <div class="summary-card-container">
        <SummaryCard
          v-bind:cardIcon="hiredCountIcon"
          v-bind:summaryDescription="hiredCountDescription"
          v-bind:totalCount="hiredCount"
        />
      </div>

      <div  class="dashboard-graph">
        <div v-if="!loading">
          <div class="chart-header">
            <div class="overview">Hiring Overview</div>
            <div class="select-container">
              <select v-model="selectedPeriod">
                <option v-for="(period,index) in selectedPeriods" v-bind:key="index">{{period}}</option>
              </select>
            </div>
          </div>
          <ChartComponent v-if="datacollection" v-bind:chartData="datacollection" />
        </div>
      </div>

      <div class="profile-highlight">
        <DashboardProfileCard
          v-bind:userName="getUserData.firstName"
          v-bind:userType="userType"
          v-bind:userLocation="getUserLocation"
          v-on:backToPostJob="$emit('backToPostJob', 'Post Job')"
          v-bind:profileUrl="getUserData.profileUrl"
        />
      </div>

      <div class="dashboard-jobs">
        <DashboardJobsList v-if="jobsList.length !== 0"
          v-bind:jobsList="jobsList"
          v-bind:jobHeading="jobHeading"
          v-on:backToJobs="$emit('backToJobs', 'Jobs')"
          v-on:creatorJobView="viewAsCreator"
        />
        <EmptyDashboardState v-else
          v-bind:emptyHeading="emptyJob"
          v-bind:desc="jobDesc"
        />
      </div>

      <div class="dashboard-applications">
        <DashboardApplicationsList v-if="applicationsList.length !== 0"
          v-bind:applicationsList="applicationsList"
          v-on:backToApplications="$emit('backToApplications', 'Applications')"
          v-on:viewApplication="showApplication"
        />
        <EmptyDashboardState v-else
          v-bind:emptyHeading="emptyApplication"
          v-bind:desc="appDesc"
        />
      </div>
    </div>
    <div v-else>
      <!-- Loader Component -->
      <Loader />
    </div>
  </div>
</template>

<script>
import SummaryCard from '../../components/SummaryCard.vue';
import DashboardProfileCard from '../../components/DashboardProfileCard.vue';
import DashboardApplicationsList from '../../components/DashboardApplicationsList.vue';
import DashboardJobsList from '../../components/DashboardJobsList.vue';
import ChartComponent from '../../components/ChartComponent.vue';
import EmptyDashboardState from '../../components/EmptyDashboardState.vue';
import Loader from '../../components/body/Loader.vue';

import jobsCountIcon from '../../assets/images/summary-jobs-count.svg';
import applicationsCountIcon from '../../assets/images/summary-applications-count.svg';
import shortlistedCountIcon from '../../assets/images/summary-shortlisted-count.svg';
import hiredCountIcon from '../../assets/images/summary-hired-count.svg';

export default {
  name: 'AgencyDashboard',
  props:['userData'],
  components:{
    EmptyDashboardState,
    ChartComponent,
    SummaryCard,
    DashboardProfileCard,
    DashboardApplicationsList,
    DashboardJobsList,
    Loader
  },
  data() {
    return{
      loading: true,
      emptyApplication:'Applications',
      appDesc:'No Applications Found',

      emptyJob:'Jobs Posted',
      jobDesc:'No Jobs Posted',
      jobHeading: 'Jobs',

      datacollection:null,
      monthsList:['This Month'],

      weekOneCountAll:0,
      weekOneCountShortlisted:0,
      weekOneCountRejected:0,

      weekTwoCountAll:0,
      weekTwoCountShortlisted:0,
      weekTwoCountRejected:0,

      weekThreeCountAll:0,
      weekThreeCountShortlisted:0,
      weekThreeCountRejected:0,

      weekFourCountAll:0,
      weekFourCountShortlisted:0,
      weekFourCountRejected:0,

      januaryCountAll:0,
      januaryCountShortlisted:0,
      januaryCountRejected:0,

      februaryCountAll:0,
      februaryCountShortlisted:0,
      februaryCountRejected:0,

      marchCountAll:0,
      marchCountShortlisted:0,
      marchCountRejected:0,

      aprilCountAll:0,
      aprilCountShortlisted:0,
      aprilCountRejected:0,

      mayCountAll:0,
      mayCountShortlisted:0,
      mayCountRejected:0,

      juneCountAll:0,
      juneCountShortlisted:0,
      juneCountRejected:0,

      julyCountAll:0,
      julyCountShortlisted:0,
      julyCountRejected:0,

      augustCountAll:0,
      augustCountShortlisted:0,
      augustCountRejected:0,

      septemberCountAll:0,
      septemberCountShortlisted:0,
      septemberCountRejected:0,

      octoberCountAll:0,
      octoberCountShortlisted:0,
      octoberCountRejected:0,

      novemberCountAll:0,
      novemberCountShortlisted:0,
      novemberCountRejected:0,

      decemberCountAll:0,
      decemberCountShortlisted:0,
      decemberCountRejected:0,

      chartDataAll:[],
      chartDataShortlisted:[],
      chartDataRejected:[],

      weekChartDataAll:[],
      weekChartDataShortlisted:[],
      weekChartDataRejected:[],

      monthChartDataAll:[],
      monthChartDataShortlisted:[],
      monthChartDataRejected:[],

      selectedPeriod:'This Month',
      selectedPeriods:[ 'This Month', 'Last Month', 'Last 3 Months', 'This Year' ],
      chartData:[],

      jobsCountIcon,
      applicationsCountIcon,
      shortlistedCountIcon,
      hiredCountIcon,

      userType:'',
      userLocation:'',

      jobError:'',
      jobsCountDescription:'Total No. of Jobs',
      jobsCount:0,
      jobsList:[],

      applicationError:'',
      applicationsCountDescription:'Applications Received',
      applicationsCount:0,
      allApplications:'',
      applicationsList: [],

      shortlistedCountDescription:'Shortlisted Applications',
      shortlistedCount:0,

      hiredCountDescription:'Candidates Hired',
      hiredCount:0,

      jobTarget: 'Jobs',
      jobEvent: 'backToJobs',
      applicationTarget: 'Applications',
      applicationEvent: 'backToApplications',
    };
  },
  computed: {
    getUserData() {
      return this.userData;
    },

    getUserLocation() {
      const location = this.userData.city && this.userData.state
      ? `${this.userData.city}, ${this.userData.state}`
      : this.userData.city ? this.userData.city
      : this.userData.state ? this.userData.state
      : null;

      return location;
    },

    getError() {
      return this.$store.state.error;
    }
  },
  methods:{
    fillData () {
      let labels = this.selectedPeriod === 'This Year' ?
        [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ] :
        ['Week 01', 'Week 02', 'Week 03', 'Week 04'];
      this.datacollection = {
        labels,
        datasets: [
          {
            label: 'Applications Received',
            backgroundColor: 'rgba(186, 83, 222, 0.3)',
            data: this.chartDataAll
          },
          {
            label: 'Shortlisted',
            backgroundColor: 'rgba(255, 124, 124, 0.3)',
            data: this.chartDataShortlisted
          },
          {
            label: 'Rejected',
            backgroundColor: 'rgba(255, 0, 0, 0.3)',
            data: this.chartDataRejected
          }
        ]
      };
    },
    viewAsCreator (jobId) {
      this.$emit('creatorJobView', jobId);
    },
    showApplication (id) {
      this.$emit('viewApplication', id);
    }
  },
  async beforeMount() {

  },
  async mounted() {
    this.userType = 'Agency';

    let jobsToList;
    let applicationsFetched;

    this.$store
          .dispatch('getMyPosts')
          .then(async (res) => {
            if (res.response){
              jobsToList = this.$store.state.myPosts.reverse();
              this.jobsCount = this.$store.state.myPosts.length;
              this.applicationsCount = this.$store.state.userData.receivedApplications.length;
              applicationsFetched = this.$store.state.userData.receivedApplications;
              this.loading = false;
            } else {
              this.jobsCount = 0;
              this.applicationsCount = 0;
              this.loading = false;
            }

            if(jobsToList && jobsToList.length){
              jobsToList.forEach((element, i)=> {
                if(!element.jobDeadline || new Date(element.jobDeadline) > Date.now()){
                  jobsToList[i]['status'] = 'Active';
                }else if(new Date(jobsToList[i].jobDeadline) <= Date.now()){
                  element['status'] = 'Closed';
                }
                this.jobsList.push(element);
              });
            }
        // Restrict length of jobs list to 6 if list exists and is greater than six;
        this.jobsCount !== 0 && this.jobsCount > 6 ?
        this.jobsList.length = 6
        : null;
        // Restrict length of applications list to 4 if list exists and is greater than four;
        if (applicationsFetched) {
          applicationsFetched.reverse().forEach((application, index) => {
            if(index < 4){
              this.applicationsList.push(application);
            }
          });
        }

        this.allApplications = applicationsFetched;

        this.shortlistedCount = 0;
        this.hiredCount = 0;

        if(this.applicationsCount !== 0){
          for(let application of applicationsFetched) {
            if(application.status === 'shortlisted') {this.shortlistedCount = this.shortlistedCount + 1;}
            else if(application.status === 'hired') {this.hiredCount = this.hiredCount + 1;}
          }
        }

        let todaysDate = new Date();

        // get month returns a zero index month
        let currentMonth = todaysDate.getMonth() + 1;

        // let prevMonth = currentMonth - 1;
        let monthCount = currentMonth - 1;

        while( monthCount > 0) {
          switch(monthCount) {
            case 1:
              this.monthsList = [...this.monthsList, 'January'];
              break;
            case 2:
              this.monthsList = [...this.monthsList, 'February'];
              break;
            case 3:
              this.monthsList = [...this.monthsList, 'March'];
              break;
            case 4:
              this.monthsList = [...this.monthsList, 'April'];
              break;
            case 5:
              this.monthsList = [...this.monthsList, 'May'];
              break;
            case 6:
              this.monthsList = [...this.monthsList, 'June'];
              break;
            case 7:
              this.monthsList = [...this.monthsList, 'July'];
              break;
            case 8:
              this.monthsList = [...this.monthsList, 'August'];
              break;
            case 9:
              this.monthsList = [...this.monthsList, 'September'];
              break;
            case 10:
              this.monthsList = [...this.monthsList, 'October'];
              break;
            case 11:
              this.monthsList = [...this.monthsList, 'November'];
              break;
            case 12:
              this.monthsList = [...this.monthsList, 'December'];
              break;
          }
          monthCount = monthCount - 1;
        }

        this.weekOneCountAll = 0;
        this.weekOneCountShortlisted = 0;
        this.weekOneCountRejected = 0;

        this.weekTwoCountAll = 0;
        this.weekTwoCountShortlisted = 0;
        this.weekTwoCountRejected = 0;

        this.weekThreeCountAll = 0;
        this.weekThreeCountShortlisted = 0;
        this.weekThreeCountRejected = 0;

        this.weekFourCountAll = 0;
        this.weekFourCountShortlisted = 0;
        this.weekFourCountRejected = 0;

        // testing out chat plotting
        if(this.applicationsCount !== 0){
          for(let application of this.allApplications) {
            let theDate = new Date(application.createdAt);
            let today = new Date();

            if(theDate.getMonth() === (today.getMonth())) {
              if(theDate.getDate() <= 7) {
                this.weekOneCountAll++;

                if(application.status === 'shortlisted') {
                  this.weekOneCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.weekOneCountRejected++;
                }
              }
              else if(theDate.getDate() > 7 && theDate.getDate() <= 14) {
                this.weekTwoCountAll++;

                if(application.status === 'shortlisted') {
                  this.weekTwoCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.weekTwoCountRejected++;
                }
              }
              else if(theDate.getDate() > 14 && theDate.getDate() <= 21) {
                this.weekThreeCountAll++;

                if(application.status === 'shortlisted') {
                  this.weekThreeCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.weekThreeCountRejected++;
                }

              }
              else if(theDate.getDate() > 21 && theDate.getDate() <= 31) {
                this.weekFourCountAll++;

                if(application.status === 'shortlisted') {
                  this.weekFourCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.weekFourCountRejected++;
                }
              }
            }
          }
        }
        this.chartDataAll = [
          this.weekOneCountAll,
          this.weekTwoCountAll,
          this.weekThreeCountAll,
          this.weekFourCountAll
        ];

        this.chartDataShortlisted = [
          this.weekOneCountShortlisted,
          this.weekTwoCountShortlisted,
          this.weekThreeCountShortlisted,
          this.weekFourCountShortlisted
        ];

        this.chartDataRejected = [
          this.weekOneCountRejected,
          this.weekTwoCountRejected,
          this.weekThreeCountRejected,
          this.weekFourCountRejected
        ];

        await this.fillData();
          });
  },
  async beforeUpdate() {
    this.weekOneCountAll = 0;
    this.weekOneCountShortlisted = 0;
    this.weekOneCountRejected = 0;

    this.weekTwoCountAll = 0;
    this.weekTwoCountShortlisted = 0;
    this.weekTwoCountRejected = 0;

    this.weekThreeCountAll = 0;
    this.weekThreeCountShortlisted = 0;
    this.weekThreeCountRejected = 0;

    this.weekFourCountAll = 0;
    this.weekFourCountShortlisted = 0;
    this.weekFourCountRejected = 0;

    this.jan;
    if(this.applicationsCount !== 0){
      switch(this.selectedPeriod) {
        case 'This Month':
          for(let application of this.allApplications) {
            let theDate = new Date(application.createdAt);
            let today = new Date();

            if(theDate.getMonth() === (today.getMonth())) {
              if(theDate.getDate() <= 7) {
                this.weekOneCountAll++;

                if(application.status === 'shortlisted') {
                  this.weekOneCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.weekOneCountRejected++;
                }
              }
              else if(theDate.getDate() > 7 && theDate.getDate() <= 14) {
                this.weekTwoCountAll++;

                if(application.status === 'shortlisted') {
                  this.weekTwoCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.weekTwoCountRejected++;
                }
              }
              else if(theDate.getDate() > 14 && theDate.getDate() <= 21) {
                this.weekThreeCountAll++;

                if(application.status === 'shortlisted') {
                  this.weekThreeCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.weekThreeCountRejected++;
                }

              }
              else if(theDate.getDate() > 21 && theDate.getDate() <= 31) {
                this.weekFourCountAll++;

                if(application.status === 'shortlisted') {
                  this.weekFourCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.weekFourCountRejected++;
                }
              }
            }
          }
          break;
        case 'Last Month':
          for(let application of this.allApplications) {
            let theDate = new Date(application.createdAt);
            let today = new Date();

            if(theDate.getMonth() === (today.getMonth() - 1)) {
              if(theDate.getDate() <= 7) {
                this.weekOneCountAll++;

                if(application.status === 'shortlisted') {
                  this.weekOneCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.weekOneCountRejected++;
                }
              }
              else if(theDate.getDate() > 7 && theDate.getDate() <= 14) {
                this.weekTwoCountAll++;

                if(application.status === 'shortlisted') {
                  this.weekTwoCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.weekTwoCountRejected++;
                }
              }
              else if(theDate.getDate() > 14 && theDate.getDate() <= 21) {
                this.weekThreeCountAll++;

                if(application.status === 'shortlisted') {
                  this.weekThreeCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.weekThreeCountRejected++;
                }

              }
              else if(theDate.getDate() > 21 && theDate.getDate() <= 31) {
                this.weekFourCountAll++;

                if(application.status === 'shortlisted') {
                  this.weekFourCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.weekFourCountRejected++;
                }
              }
            }
          }
          break;
        case 'Last 3 Months':
          for(let application of this.allApplications) {
            let theDate = new Date(application.createdAt);
            let today = new Date();

            if(theDate.getMonth() === (today.getMonth() - 3)) {
              if(theDate.getDate() <= 7) {
                this.weekOneCountAll++;

                if(application.status === 'shortlisted') {
                  this.weekOneCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.weekOneCountRejected++;
                }
              }
              else if(theDate.getDate() > 7 && theDate.getDate() <= 14) {
                this.weekTwoCountAll++;

                if(application.status === 'shortlisted') {
                  this.weekTwoCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.weekTwoCountRejected++;
                }
              }
              else if(theDate.getDate() > 14 && theDate.getDate() <= 21) {
                this.weekThreeCountAll++;

                if(application.status === 'shortlisted') {
                  this.weekThreeCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.weekThreeCountRejected++;
                }

              }
              else if(theDate.getDate() > 21 && theDate.getDate() <= 31) {
                this.weekFourCountAll++;

                if(application.status === 'shortlisted') {
                  this.weekFourCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.weekFourCountRejected++;
                }
              }
            }
          }
          break;
        case 'This Year':
          for(let application of this.allApplications) {
            let theDate = new Date(application.createdAt);
            let today = new Date();

            if(theDate.getFullYear() === (today.getFullYear())) {
              if(theDate.getMonth() === 0) {
                this.januaryCountAll++;

                if(application.status === 'shortlisted') {
                  this.januaryCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.januaryCountRejected++;
                }
              }
              else if(theDate.getMonth() === 1) {
                this.februaryCountAll++;

                if(application.status === 'shortlisted') {
                  this.februaryCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.februaryCountRejected++;
                }
              }
              else if(theDate.getMonth() === 2) {
                this.marchCountAll++;

                if(application.status === 'shortlisted') {
                  this.marchCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.marchCountRejected++;
                }
              }
              else if(theDate.getMonth() === 3) {
                this.aprilCountAll++;

                if(application.status === 'shortlisted') {
                  this.aprilCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.aprilCountRejected++;
                }
              }
              else if(theDate.getMonth() === 4) {
                this.mayCountAll++;

                if(application.status === 'shortlisted') {
                  this.mayCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.mayCountRejected++;
                }
              }
              else if(theDate.getMonth() === 5) {
                this.juneCountAll++;

                if(application.status === 'shortlisted') {
                  this.juneCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.juneCountRejected++;
                }
              }
              else if(theDate.getMonth() === 6) {
                this.julyCountAll++;

                if(application.status === 'shortlisted') {
                  this.julyCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.julyCountRejected++;
                }
              }
              else if(theDate.getMonth() === 7) {
                this.augustCountAll++;

                if(application.status === 'shortlisted') {
                  this.augustCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.augustCountRejected++;
                }
              }
              else if(theDate.getMonth() === 8) {
                this.septemberCountAll++;

                if(application.status === 'shortlisted') {
                  this.septemberCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.septemberCountRejected++;
                }
              }
              else if(theDate.getMonth() === 9) {
                this.octoberCountAll++;

                if(application.status === 'shortlisted') {
                  this.octoberCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.octoberCountRejected++;
                }
              }
              else if(theDate.getMonth() === 10) {
                this.novemberCountAll++;

                if(application.status === 'shortlisted') {
                  this.novemberCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.novemberCountRejected++;
                }
              }
              else if(theDate.getMonth() === 11) {
                this.decemberCountAll++;

                if(application.status === 'shortlisted') {
                  this.decemberCountShortlisted++;
                }
                else if(application.status === 'declined') {
                  this.decemberCountRejected++;
                }
              }
            }
          }
          break;
      }
    }

    if(this.selectedPeriod === 'This Year') {
      this.chartDataAll = [
        this.januaryCountAll, this.februaryCountAll,
        this.marchCountAll, this.aprilCountAll, this.mayCountAll,
        this.juneCountAll, this.julyCountAll, this.augustCountAll,
        this.septemberCountAll, this.octoberCountAll, this.novemberCountAll,
        this.decemberCountAll
      ];

      this.chartDataShortlisted = [
        this.januaryCountShortlisted, this.februaryCountShortlisted,
        this.marchCountShortlisted, this.aprilCountShortlisted, this.mayCountShortlisted,
        this.juneCountShortlisted, this.julyCountShortlisted, this.augustCountShortlisted,
        this.septemberCountShortlisted, this.octoberCountShortlisted, this.novemberCountShortlisted,
        this.decemberCountShortlisted
      ];

      this.chartDataRejected = [
        this.januaryCountRejected, this.februaryCountRejected,
        this.marchCountRejected, this.aprilCountRejected, this.mayCountRejected,
        this.juneCountRejected, this.julyCountRejected, this.augustCountRejected,
        this.septemberCountRejected, this.octoberCountRejected, this.novemberCountRejected,
        this.decemberCountRejected
      ];
    } else {
      this.chartDataAll = [
        this.weekOneCountAll,
        this.weekTwoCountAll,
        this.weekThreeCountAll,
        this.weekFourCountAll
      ];

      this.chartDataShortlisted =[
        this.weekOneCountShortlisted,
        this.weekTwoCountShortlisted,
        this.weekThreeCountShortlisted,
        this.weekFourCountShortlisted
      ];
      this.chartDataRejected =[
        this.weekOneCountRejected,
        this.weekTwoCountRejected,
        this.weekThreeCountRejected,
        this.weekFourCountRejected
      ];
    }

    await this.fillData();

  }
};
</script>

<style scoped>
  .chart-header {
    color:var(--colorSecondary);
    padding:2.625rem 2.5rem 2.625rem 1.438rem;
    text-align:center;
    display:flex;
    justify-content:space-between;
    align-items:center;
  }

  .chart-header .overview {
    font-weight:600;
    font-size:1.375rem;

  }

  .chart-header .select-container {
    border: 3px solid #071A52;
    border-radius: 20px;
  }

  .select-container select, .select-container option {
    outline:none;
    color:#071a52;
    font-weight:bold;
    font-size:12px;
    border:none;
    border-radius:20px;
    padding:12px;
  }

  .dashboard-main {
    padding: 2.5rem;
  }

  .dashboard-area {
    border-radius:15px;
    /* margin:2.188rem; */
    display:grid;
    gap:2.188rem;
    grid-template-columns:1fr 1fr 1fr 1fr;
    /* grid-template-rows:1fr 4fr 3fr; */
    grid-template-rows: 0.5fr 1.5fr 1.5fr;
  }

  .dashboard-area > div {
    background:var(--white);
    min-height:154px;
    border-radius:15px;
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    -webkit-box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    -moz-box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
  }
  .summary-card-container {
    display:flex;
  }

  .profile-highlight {
    display:flex;
  }

  .dashboard-graph,.dashboard-jobs {
    grid-column: 1 / span 3;
  }

  @media only screen and (max-width:1178px) {
    .dashboard-area {
      display:grid;
      gap:2.188rem;
      grid-template-columns:1fr 1fr;
      grid-template-rows:auto;
    }
    .dashboard-graph,.dashboard-jobs {
      grid-column: 1 / span 2;
    }
    .dashboard-applications {
      grid-column: 2/span 1;
      grid-row:4/span 1
    }
  }

  @media only screen and (max-width:1078px) {
    .dashboard-area {
      display:grid;
      gap:2.188rem;
      grid-template-columns:1fr 1fr;
      grid-template-rows:auto;
    }
    .dashboard-graph,.dashboard-jobs {
      grid-column: 1 / span 2;
    }
    .dashboard-applications {
      grid-column:2/span 1;
      grid-row:3/span 1;
    }
  }

  @media only screen and (max-width:990px) {
    .dashboard-area {
      display:grid;
      gap:2.188rem;
      grid-template-columns:1fr 1fr;
      grid-template-rows:auto;
    }
    .dashboard-graph,.dashboard-jobs {
      grid-column: 1 / span 2;
    }
    .dashboard-applications {
      grid-column:2/span 1;
      grid-row:3/span 1
    }
  }


  @media only screen and (max-width: 767px) {
    .dashboard-area{
      display:grid;
      gap:2.188rem;
      justify-content:center;
      grid-template-columns:1fr;
      grid-template-rows:auto;
    }
    .dashboard-graph,.dashboard-jobs {
      grid-column: 1 / span 1;
    }
    .dashboard-applications {
      grid-column:1/span 1;
      grid-row:6/span 1
    }
  }

  @media only screen and (max-width: 565px) {

  }

  @media only screen and (max-width: 420px) {

  }

</style>
